import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row items-center space-x-4"
}
const _hoisted_2 = { class: "flex flex-col flex-1 w-full leading-tight" }

import { PropType, computed } from 'vue';
import BaseButton from '@/lib/components/Button/BaseButton.vue';
import BaseIcon from '@/lib/components/Icon/BaseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAlert',
  props: {
  color: {
    type: String as PropType<string | string[]>,
    default: 'primary',
    validator: (value: string) => ['primary', 'success', 'alert', 'danger'].includes(value)
  },
  value: {
    type: [Array, String],
    default: null
  },
  badge: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: ''
  },
  list: {
    type: Boolean,
    default: false
  },
  button: {
    type: Object,
    default: null
  }
},
  setup(__props) {

const props = __props;



const labelArray = computed<string[]>(() => Array.isArray(props.value) ? props.value as string[] : [props.value]);
const textColorClass = computed<string>(() => `text-${props.color}-800`);
const bgColorClass = computed<string>(() => `bg-${props.color}-100`);

return (_ctx: any,_cache: any) => {
  const _component_MkBadge = _resolveComponent("MkBadge")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row min-h-12 text-left space-x-4 rounded-md p-3", [_unref(textColorClass), _unref(bgColorClass), !__props.value || _unref(labelArray).length > 1 ? 'items-start' : 'items-center']])
  }, [
    (__props.badge || __props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.badge)
            ? (_openBlock(), _createBlock(_component_MkBadge, {
                key: 0,
                filled: "",
                label: __props.badge,
                color: __props.color,
                size: "small"
              }, null, 8, ["label", "color"]))
            : _createCommentVNode("", true),
          (__props.icon)
            ? (_openBlock(), _createBlock(BaseIcon, {
                key: 1,
                name: __props.icon,
                height: "16px",
                class: _normalizeClass({ 'mt-1': !__props.value || _unref(labelArray).length > 1 })
              }, null, 8, ["name", "class"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (__props.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(labelArray), (str, index) => {
            return (_openBlock(), _createElementBlock("span", { key: str }, [
              (__props.list && __props.value.length > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(index + 1) + ". ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(str), 1)
            ]))
          }), 128))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    (__props.button)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 1,
          size: "sm",
          color: "ghost",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.button.click()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.button.label), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})